import { FormContextValues } from '@dreryk/react-common';
import { ButtonGroup, ButtonGroupItems } from '@dreryk/react-components';

import { calendarTranslationKeys } from '../../translations';
import { CalendarMode } from '../CalendarController.types';

const items: ButtonGroupItems<CalendarMode> = [
   {
      name: 'specialist',
      testId: 'specialist',
      label: calendarTranslationKeys.sidePanel.calendarModeButtonGroup.items.specialist,
   },
   {
      name: 'healthcareLocation',
      testId: 'healthcareLocation',
      label: calendarTranslationKeys.sidePanel.calendarModeButtonGroup.items.healthcareLocation,
   },
];

type CalendarModeButtonGroupProps = Pick<FormContextValues<{ mode: CalendarMode }>, 'register'>;

export const CalendarModeButtonGroup = (props: CalendarModeButtonGroupProps): JSX.Element => {
   return <ButtonGroup controller={props.register('mode')} items={items} testId={'calendarMode'} compact />;
};
